<template>
  <form @submit.prevent="handleSubmit">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <span v-if="contentType === 'image'">Update Image</span>
          <span v-if="contentType === 'video'">Update Video</span>
        </p>
      </header>

      <section class="modal-card-body has-text-centered">
        <img :src="src" v-if="contentType === 'image'" />
        <video :src="src" v-if="contentType === 'video'"></video>
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()" :disabled="uploading">Cancel</button>
        <button class="button is-primary" :class="{ 'is-loading': uploading }">Update</button>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    file: {},

    endpoint: {
      type: String
    },

    updated: {
      type: Function
    },

    fileFieldName: {
      type: String,
      default: "image"
    },

    with: {
      type: Object,
      default: () => {}
    },

    contentType: {
      type: String,
      default: "image"
    }
  },

  data() {
    return {
      uploading: false
    };
  },

  computed: {
    src() {
      return URL.createObjectURL(this.file);
    }
  },

  methods: {
    handleSubmit() {
      this.uploading = true;

      this.$http
        .post(this.endpoint, this.formData())
        .then(response => {
          this.onSuccess(response);

          this.uploading = false;
        })
        .catch(error => {
          this.onFail(error);

          this.uploading = false;
        });
    },

    onSuccess({ data }) {
      if (typeof this.updated === "function") {
        this.updated(data.data);
      }

      this.$emit("close");
    },

    onFail(error) {
      new window.FailedResponseHandler(error).handle();
    },

    formData() {
      let formData = new window.FormData();

      formData.append(this.fileFieldName, this.file);

      for (var field in this.with) {
        formData.append(field, this.with[field]);
      }

      return formData;
    }
  }
};
</script>
